import { useState } from "react";
import { Modal, NUMERIC } from "pages/admin/ui";
import {
  ACTION_LABEL,
  FEATURES,
  INPUT_OF,
  LABEL_HELP,
  LOAD_RULES,
  NOT_LOADED,
  SAMPLE_OF,
} from "./aiFormat";

// 모든 영역에 공통인 규칙 — 영역마다 반복하지 않고 맨 위에 한 번
const COMMON_RULES = [
  "코치 액션 1건 = 1행 (append-only). 같은 원본은 중복 기준에 따라 한 번만 쌓인다.",
  "라벨은 코치가 AI 출력을 어떻게 썼는지. 학습 정답은 코치 값이고, 관리자가 보완하면 보완본이다.",
  "입력은 코치 액션 시점의 스냅샷이다.",
  "train/valid/test 분할은 내담자 단위로 자동 배정된다.",
];

const TH = "px-2 py-2 font-semibold";
const TD = "px-2 py-2";

/**
 * 적재 규칙 — 어떤 코치 액션이 어떤 행이 되는지. 영역 탭과 상관없이 전 영역 규칙을 모달 하나로 보여준다.
 */
export default function LoadRules() {
  const [open, setOpen] = useState(false);

  // 모달은 설명 줄 밖에 둔다 — 설명 줄의 글자색·크기를 물려받지 않게
  return (
    <>
      <div className="flex items-center justify-between gap-4 text-sm text-slate-500">
        <span>
          코치 액션 로그 기반 파인튜닝 데이터셋 관리 — SFT(messages) ·
          DPO(chosen/rejected) · RL(reference + reward) 샘플 구성.
          <br />
          train/valid/test 분할은 유저 단위로 자동 배정됨.
        </span>
        <button
          type="button"
          onClick={() => setOpen(true)}
          className="shrink-0 text-slate-400 underline underline-offset-2 hover:text-slate-600"
        >
          적재 규칙 보기
        </button>
      </div>

      {open && (
        <Modal
          title="적재 규칙"
          subject="코치 액션 하나가 한 행 (append-only)"
          width="1200px"
          onClose={() => setOpen(false)}
        >
          <div className="flex flex-col gap-8">
            <ul className="list-disc rounded-lg bg-slate-50 px-4 py-3 pl-8 text-sm text-slate-600">
              {COMMON_RULES.map((rule) => (
                <li key={rule}>{rule}</li>
              ))}
            </ul>

            {FEATURES.map(({ key: feature, label }) => (
              <section key={feature} className="flex flex-col gap-3">
                <h3 className="text-sm font-semibold text-slate-900">
                  {label}
                </h3>
                <div className="overflow-x-auto">
                  <table className="w-full border-collapse text-sm">
                    <thead>
                      <tr className="border-b border-slate-200 text-left text-xs text-slate-500">
                        <th className={TH}>코치 액션</th>
                        <th className={`cursor-help ${TH}`} title={LABEL_HELP}>
                          <span className="border-b border-dotted border-slate-300">
                            라벨
                          </span>
                        </th>
                        <th className={TH}>AI 출력 → 코치 출력</th>
                        <th className={TH}>중복 기준</th>
                      </tr>
                    </thead>
                    <tbody>
                      {LOAD_RULES[feature].map((rule) => (
                        <tr
                          key={rule.when}
                          className="border-b border-slate-100 align-top last:border-b-0"
                        >
                          <td className={`${TD} text-slate-900`}>
                            {rule.when}
                            <div className="mt-0.5 text-xs text-slate-400">
                              <code className={NUMERIC}>{rule.action}</code>{" "}
                              {ACTION_LABEL[rule.action]}
                            </div>
                          </td>
                          <td className={`${TD} text-slate-700`}>
                            {rule.label}
                          </td>
                          <td className={`${TD} text-slate-500`}>
                            {rule.ai} → {rule.coach}
                          </td>
                          <td className={`${TD} text-slate-500`}>
                            {rule.dedupe}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <dl className="grid grid-cols-[88px_1fr] gap-x-3 gap-y-1.5 text-sm">
                  <dt className="text-xs font-semibold leading-5 text-slate-500">
                    입력
                  </dt>
                  <dd className="text-slate-600">{INPUT_OF[feature]}</dd>
                  <dt className="text-xs font-semibold leading-5 text-slate-500">
                    학습 샘플
                  </dt>
                  <dd className="text-slate-600">{SAMPLE_OF[feature]}</dd>
                  <dt className="text-xs font-semibold leading-5 text-slate-500">
                    적재 안 함
                  </dt>
                  <dd>
                    <ul className="list-disc pl-5 text-slate-600">
                      {NOT_LOADED[feature].map((item) => (
                        <li key={item}>{item}</li>
                      ))}
                    </ul>
                  </dd>
                </dl>
              </section>
            ))}
          </div>
        </Modal>
      )}
    </>
  );
}
